module.exports = __webpack_public_path__ + "static/media/abexhealth.68392ec7.png";